import { t } from 'i18next';
import { sum } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import { ILog } from 'bom/types';
import { Total, TotalPrice } from 'core/elements';
import { useAgGridClientTableContext } from 'core/states';

export const TotalsStatusBar = () => {
  const [totals, setTotals] = useState<{
    cost: number | undefined;
    price: number | undefined;
    duration: number | undefined;
  }>({
    cost: undefined,
    price: undefined,
    duration: undefined,
  });

  const classNames = 'ag-status-name-value ag-status-panel';

  const { rows } = useAgGridClientTableContext();

  const calculateTotalCost = useCallback((records: ILog[]) => {
    const cost = sum(records.map((record) => record.cost * record.duration)) || undefined;
    const price = sum(records.map((record) => record.price * record.duration)) || undefined;
    const duration = sum(records.map((record) => Number(record.duration))) || undefined;

    setTotals({ cost, price, duration });
  }, []);

  useEffect(() => {
    calculateTotalCost(rows as ILog[]);
  }, [calculateTotalCost, rows]);

  return (
    <>
      <TotalPrice label={t('labelCost')} value={totals?.cost} options={{ classNames }} />
      <TotalPrice label={t('labelPrice')} value={totals?.price} options={{ classNames }} />
      <Total label={t('labelDurationHours')} value={totals?.duration} options={{ classNames }} />
    </>
  );
};
